import{useId as e}from"react";function t(){return`gate-js${e().replaceAll(":","__")}`}export{t as useSafeId};
